import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'ct-textbox-cleaner',
  templateUrl: './textbox-cleaner.component.html'
})
export class TextboxCleanerComponent {
  @Input()
  public control: AbstractControl;
  public clear() {
    this.control.patchValue('');
  }
}
